/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
 
    $(document).on('click', '.nav-toggle', function(){
        $(this).toggleClass('on');
        $('html').toggleClass('nav-on');
        $('.main-navigation').slideToggle();
    });
      
    $(document).on('click', '.main-navigation .menu > li.menu-item-has-children > a', function(e){
        if($(window).width() <= 899){
            e.preventDefault();
            $(this).toggleClass('on');
            $(this).next().slideToggle();
        }
    });
     
  
  
  
   function appHeight() {
      var wh = $(window).innerHeight();
      document.documentElement.style
        .setProperty('--app-height', wh + 'px');

    }
    window.addEventListener('resize', appHeight)
    appHeight();

    $(window).scroll(function(e){
      var ST = $(this).scrollTop();
      if(ST >= 50){
        $('.site-header').addClass('sticky');
      }else{
        $('.site-header').removeClass('sticky');
      }

    });
     $('.series-cl').slick({
      dots: false,
      infinite: false,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      nextArrow: '<span class="slick-arrow slick-next"><svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect xmlns="http://www.w3.org/2000/svg" width="48" height="48" rx="24"/><path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" d="M18.8013 14.8017C18.2658 15.3373 18.2658 16.2056 18.8013 16.7412L26.0602 24L18.8013 31.2589C18.2658 31.7944 18.2658 32.6628 18.8013 33.1983C19.3369 33.7339 20.2053 33.7339 20.7408 33.1983L28.9694 24.9698C29.505 24.4342 29.505 23.5659 28.9694 23.0303L20.7408 14.8017C20.2053 14.2661 19.3369 14.2661 18.8013 14.8017Z" clip-rule="evenodd"/></svg></span>',
      prevArrow: '<span class="slick-arrow slick-prev"><svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect xmlns="http://www.w3.org/2000/svg" width="48" height="48" rx="24"/><path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" d="M28.9701 14.8017C29.5057 15.3373 29.5057 16.2056 28.9701 16.7412L21.7113 24L28.9701 31.2589C29.5057 31.7944 29.5057 32.6628 28.9701 33.1983C28.4346 33.7339 27.5662 33.7339 27.0306 33.1983L18.8021 24.9698C18.2665 24.4342 18.2665 23.5659 18.8021 23.0303L27.0306 14.8017C27.5662 14.2661 28.4346 14.2661 28.9701 14.8017Z" clip-rule="evenodd"/></svg></span>',
          responsive: [
        {
          breakpoint: 860,
          settings: {
            slidesToShow: 1,
            infinite: true,
          }
        }
      ]
    });
    $(document).on('click', '.blog-list-filter a', function (e) {
        e.preventDefault();
        var $el = $(this),
            link = $el.attr('href');
        $('.blog-list-filter a').removeClass('active');
        $el.addClass('active');
        $('#loadmorecontainer').addClass('loading'); 
        $("<div>").load(link + " #loadmorecontainer", function () {
            $("#loadmorecontainer").html($(this).find("#loadmorecontainer").html());
            $('#loadmorecontainer').removeClass('loading');
            history.pushState({}, '', link);
        });             
    });
     $(document).on('click', '.awsm-paginate a', function (e) {
        e.preventDefault();
        var $el = $(this),
            link = $el.attr('href');
        $('#loadmorecontainer').addClass('loading'); 
        $("<div>").load(link + " #loadmorecontainer", function () {
            $("#loadmorecontainer").html($(this).find("#loadmorecontainer").html());
            $('#loadmorecontainer').removeClass('loading');
             var href = '#blog-list',
                hHeight = $('.site-header').outerHeight(),
                offsetTop = href === "#" ? 0 : $(href).offset().top;
                history.pushState({}, '', link);
            $('html, body').stop().animate({
                scrollTop: offsetTop - hHeight
            }, 300);
        });             
    });
     $(document).on('submit', '.search-form form', function (e) {
        e.preventDefault();
        var $el = $(this),
            url = new URL($el.attr('action'));
            url.searchParams.append('q', $el.find('input').val());
            var link = url;
            var formValues= $(this).serialize();
            
        $('#loadmorecontainer').addClass('loading'); 
        $("<div>").load(link + " #loadmorecontainer", function () {
            $("#loadmorecontainer").html($(this).find("#loadmorecontainer").html());
            $('#loadmorecontainer').removeClass('loading');
            history.pushState({}, '', link);
        });             
    });
     $(document).on('click', '.search-toggle', function(e){
      e.preventDefault();
      $(this).toggleClass('on');
      $('.search-form').slideToggle();
      $('#s').focus();
     });
     /**
      Share popup window
    **/
     var popupCenter = function(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 3) - (h / 3)) + dualScreenTop;

        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
          newWindow.focus();
        }
      };
    $(document).on( "click", '.share-popup', function(e) {
      var _this = $(this);
      popupCenter(_this.attr('href'), _this.find('.text').html(), 580, 470);
      e.preventDefault();
    });
    

    $('.copy-clipboard').on('click', function(e) {
      var $temp = $("<input>");
      var $url = $(this).attr('href');
      e.preventDefault();
      $("body").append($temp);
      $temp.val($url).select();
      document.execCommand("copy");
      $temp.remove();
      $(this).addClass('copied');
      var $el = $(this);
      setTimeout(function() {
           $el.removeClass('copied');
        }, 2000);
    })
    $(document).on('gform_confirmation_loaded', function(event, formId){
          if(formId == 2) {
              var $pdf = $('#report-download').data('url');
              $('#report-download').attr('href', $pdf);
              $('#report-download')[0].click();
          } 
      });

});